import styled from 'styled-components'
import { flexbox, FlexboxProps, padding, PaddingProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;
  justify-content: center;
  background-color: ${themeGet('colors.background.screenContrast')};

  ${padding}
`

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexboxProps>`
  display: flex;
  flex-direction: column;
  gap: ${themeGet('space.10')}px;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX}px;

  ${padding}
  ${flexbox}
`
